/* © 2017-2026 Booz Allen Hamilton Inc. All Rights Reserved. */

import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import isEmpty from 'lodash/isEmpty';
import TripSearchResultList from '../components/TripSearchResultList';
import { scrollTo } from '../utils/uiUtils';
import * as tripPlannerActions from '../actions/tripPlanner';

const propTypes = {
    tripPlanner: PropTypes.any,
    dispatch: PropTypes.func.isRequired,
};

class TripSearchResultListContainer extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activeDestinationListIndex: 0,
            directions: [],
            radius: null,
            uiFilters: [],
            startDate: this.props.tripPlanner.trip.start_date,
            endDate: this.props.tripPlanner.trip.end_date,
        };
    }

    componentDidMount() {
        this.refresh();
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        // scroll to list for specific selected destination
        if (
            nextProps.tripPlanner.activeDestinationListIndex !==
            this.state.activeDestinationListIndex
        ) {
            if (this._ref) {
                const index = nextProps.tripPlanner.activeDestinationListIndex;
                if (index > 0) {
                    this.scrollToIndex(index);
                    this.setState({
                        activeDestinationListIndex: index,
                    });
                }
            }
        }
        let nextState = {};
        if (
            nextProps.tripPlanner.uiFilters &&
            JSON.stringify(nextProps.tripPlanner.uiFilters) !==
                JSON.stringify(this.state.uiFilters)
        ) {
            nextState = Object.assign(nextState, {
                uiFilters: nextProps.tripPlanner.uiFilters,
            });
        }

        if (
            nextProps.tripPlanner.directions &&
            JSON.stringify(nextProps.tripPlanner.directions) !==
                JSON.stringify(this.state.directions)
        ) {
            nextState = Object.assign(nextState, {
                directions: nextProps.tripPlanner.directions,
            });
        }

        if (
            nextProps.tripPlanner.trip &&
            nextProps.tripPlanner.trip.radius !== this.state.radius
        ) {
            nextState = Object.assign(nextState, {
                radius: nextProps.tripPlanner.trip.radius,
            });
        }

        if (
            nextProps.tripPlanner.trip.start_date !== this.state.startDate ||
            nextProps.tripPlanner.trip.end_date !== this.state.endDate
        ) {
            nextState = Object.assign(nextState, {
                startDate: nextProps.tripPlanner.trip.start_date,
                endDate: nextProps.tripPlanner.trip.end_date,
            });
        }

        if (!isEmpty(nextState)) {
            this.setState(nextState);
            this.refresh();
        }
    }

    refresh() {
        setTimeout(() => {
            this.props.tripPlanner.trip.destinations.forEach((destination, index) => {
                if (index > 0) {
                    this.props.dispatch(
                        tripPlannerActions.fetchTripPlannerListSearchResults(
                            destination,
                            index
                        )
                    );
                }
            });
        }, 100);
    }

    scrollToIndex(index) {
        const el = this._ref.children[index - 1];
        const offset = el.offsetTop;
        const to = offset - this._ref.offsetTop - 10;
        scrollTo(this._ref, to, 100);
    }

    renderDestinationLists() {
        const lists = [];
        this.props.tripPlanner.trip.destinations.forEach((destination, index) => {
            if (index > 0) {
                lists.push(
                    <TripSearchResultList
                        key={`destination_list_${index}`}
                        destination={destination}
                        destinationIndex={index}
                    />
                );
            }
        });
        return lists;
    }

    render() {
        return (
            <div
                ref={(ref) => (this._ref = ref)}
                className="trip-planner-search-results-list-container"
            >
                {this.renderDestinationLists()}
            </div>
        );
    }
}

TripSearchResultListContainer.propTypes = propTypes;

function select(state) {
    return {
        tripPlanner: state.tripPlanner,
    };
}

export default connect(select)(TripSearchResultListContainer);
